import { Component } from '@angular/core';
import { LoadingController, NavParams, ToastController, ViewController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { DishServices } from '../../../dish/services';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SearchReservationsServices } from '../../../services/searchsReservation';
import { SearchServices } from '../../../services/searchs';
import { CustomersServices } from '../../../customers/services';
import { EmailServices } from '../../../services/emailServices';
import { OdsServices } from '../../../ods/services';
import { TakeawayServices } from '../../../takeaway/services';
import { PrintServices } from '../../../services/printServices';
import { TPVServices } from '../../../tpv/services';
import { HttpClient } from '@angular/common/http';

/**
 * Generated class for the CompCreateReservationPage page.
 * Component que carga estilo modal para crear/editar una reserva
 *
 */

@Component({
  selector: 'create-takeaway',
  templateUrl: 'create-takeaway.html',
})
export class CompCreateTakeawayPage {

  public form: FormGroup;
  update_state: boolean = false;
  table: any = [];
  orders: any = [];
  show_glovo: boolean = false;
  show_customer: boolean = false;
  show_deliverect: boolean = false;
  show_ordatic: boolean = false;
  show_girona: boolean = false;
  show_notes: boolean = false;
  customerComment: string = '';

  constructor(public dishServices: DishServices,
    public globals: Globals,
    public viewCtrl: ViewController,
    public translate: TranslateService,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public toastCtrl: ToastController,
    public searchServices: SearchServices,
    public searchReservationsServices: SearchReservationsServices,
    public customersServices: CustomersServices,
    public emailServices: EmailServices,
    public odsServices: OdsServices,
    public takeawayServices: TakeawayServices,
    public printServices: PrintServices,
    public tpvServices: TPVServices,
    public loadingCtrl: LoadingController,
    public http: HttpClient) {
    //get nav params
    this.update_state = this.navParams.get('update_state');
    this.table = this.navParams.get('table');
    this.customerComment = this.navParams.get('customerComment') || '';
  }

  async ngOnInit() {
    if (this.update_state) {
      this.orders = this.odsServices.ordersList.filter(x => x.table_uid === this.table.UID);
      this.globals.GAtrackView('Ods', 'Ods - View', this.globals.restaurant.email, 'View', 'View ods', 'Ods', '');
    }
  }

  close() {
    this.viewCtrl.dismiss();
  }

  fullHeight() {
    if (this.globals.platform_width === 'desktop') {
      let cssClasses = {
        'height-100': true,
      }
      return cssClasses;
    } else {
      let cssClasses = {
        'height-100': true,
      }
      return cssClasses;
    }
  }

  btnClass(state) {
    let cssClasses = {};
    if (state === 'failed' || state === 'cancelled') { //Canceladas | Fallidas
      cssClasses = {
        'btn-outline-denied': true
      }
    } else if (state === 'stateless') { //Sin estado
      cssClasses = {
        'btn-outline-not-presented': true
      }
    } else if (state === 'accepted' || state === 'completed') { //Aceptadas | Completadas
      cssClasses = {
        'btn-outline-accepted': true
      }
    } else if (state === 'received' || state === 'delayed_15' || state === 'delayed_30') { //Pendientes | En retraso
      cssClasses = {
        'btn-outline-pending': true
      }
    } else { //Otros
      cssClasses = {
        'btn-outline-in-table': true
      }
    }
    return cssClasses;
  }

  btnText(state) {
    let cssClasses = {};
    if (state === 'failed' || state === 'cancelled') { //Canceladas | Fallidas
      cssClasses = {
        'text-denied': true
      }
    } else if (state === 'stateless') { //Sin estado
      cssClasses = {
        'text-not-presented': true
      }
    } else if (state === 'accepted' || state === 'completed') { //Aceptadas | Completadas
      cssClasses = {
        'text-accepted': true
      }
    } else if (state === 'received' || state === 'delayed_15' || state === 'delayed_30') { //Pendientes | En retraso
      cssClasses = {
        'text-pending': true
      }
    } else { //Otros
      cssClasses = {
        'text-in-table': true
      }
    }
    return cssClasses;
  }

  caseNoIntegration(table) {
    let cssClasses = {};
    if (this.globals.restaurant.deliverect == true && table.deliverect_channel_order_display_id) {
      cssClasses = {
        'col-sm-6': true,
        'col-sm-11': false
      }
    } else if (this.globals.restaurant.ordatic == true && table.ordatic_order_display_id) {
      cssClasses = {
        'col-sm-6': true,
        'col-sm-11': false
      }
    } else if (table.girona_id_order || table.girona_id_partner) {
      cssClasses = {
        'col-sm-6': true,
        'col-sm-11': false
      }
    } else {
      cssClasses = {
        'col-sm-6': false,
        'col-sm-11': true
      }
    }
    return cssClasses;
  }

  changeState(state) {
    this.table.order_state = state;
    const tableToUpdate = { ...this.table };
    delete tableToUpdate.UID;
    //actulizar el estado del takeaway
    this.odsServices.firestore.collection('tables').doc(this.table.UID).update(tableToUpdate);
    this.odsServices.filter_by_state = state;
    //send email
    this.takeawayServices.sendEmailOrderState(this.table, this.odsServices.formatState(state), this.table.customer_email, this.table.customer_name, this.table.customer_phone, this.table.customer_address);
    //case deliverect
    if (this.table.deliverect_order_id != undefined && this.table.deliverect_order_id && this.globals.restaurant.deliverect != undefined && this.globals.restaurant.deliverect) {
      this.table.deliverect_order_state = this.takeawayServices.getCodeDeliverect(state);
      //actualizar el estado en deliverect
      this.updateDeliverect(this.table.deliverect_order_id, state);
    }
    //actualizar las orders del takeaway
    this.odsServices.firestore.collection('orders').where('table_uid', '==', this.table.UID).get().then((snapshot) => {
      if (snapshot.size > 0) {
        snapshot.forEach((doc) => {
          const data = { ...doc.data(), UID: doc.id };
          this.odsServices.firestore.collection('orders').doc(data.UID).update({
            'order_state': state
          });
        });
      }
    });
  }

  async printTakeawayTicket() {
    this.globals.GAtrackView('TakeAway', 'TakeAway - Ticket - Print', this.globals.restaurant.email, 'View', 'Print ticket', 'TakeAway', '');
    //getIndexByTableuid
    await this.takeawayServices.getIndexByTableuid();
    //get ticket number
    await this.takeawayServices.getTicketNumber(this.globals.restaurant_uid, this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].cash_uid);
    //volver a buscar los elementos para que tengan variations i variation_add que los limpia la funcion anterior
    this.takeawayServices.selected_list = this.takeawayServices.listSelectedTicket('name', this.globals.objectToArray(this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].ticket.list));

    // caso native
    if (this.globals.restaurant.printer_type == 'native') {
        this.takeawayServices.orders_print = 'all';
        //getIndexByTableuid
        await this.takeawayServices.getIndexByTableuid();
        //
        await this.takeawayServices.getOrdersAllPrint(this.globals.restaurant_uid, this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].UID);
        //
        this.globals.print_content = document.getElementById('print_ods_takeaway_ticket_normal');
        //
        this.printServices.printNow('print_ods_takeaway_ticket_normal');
    } else { // caso services
        //getIndexByTableuid
        await this.takeawayServices.getIndexByTableuid();
        //send to print
        this.printServices.prepareTicket(
            this.takeawayServices.listSelectedTicket('name', this.globals.objectToArray(this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].ticket.list))[0],
            this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].ticket.date.toDate(),
            this.takeawayServices.totalTicketSelectedNoTax(this.takeawayServices.selected_table_tpv_index, this.globals.RESTAURANT_TAX),
            this.takeawayServices.totalTicketSelected(this.takeawayServices.selected_table_tpv_index),
            this.tpvServices.calculateIva(this.takeawayServices.totalTicketSelected(this.takeawayServices.selected_table_tpv_index), this.takeawayServices.totalTicketSelectedNoTax(this.takeawayServices.selected_table_tpv_index, this.globals.RESTAURANT_TAX), this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].ticket),
            this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].ticket.waiter,
            this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].room,
            this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].name,
            this.globals.restaurant.tickets.footer,
            'tk',
            this.takeawayServices.ticket_num_return,
            this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].ticket,            
            this.globals.restaurant.printer_type,
            false,
            this.customerComment
        );
    }
  }

  async pay(type) {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-cobrando')
    });
    loadingPopup.present();
    await this.takeawayServices.cashTicketPay(type, this.takeawayServices.selected_type);
    loadingPopup.dismiss();
  }

  async updateDeliverect(order_id, status) {
    await this.http.post(this.globals.analytics_path + 'deliverect_update_status', {
      orderid: order_id,
      status: this.takeawayServices.getCodeDeliverect(status),
      uid_restaurant: this.table.UID_RESTAURANT
    }, {}).subscribe(async data => {

    });
  }

  change_show_glovo() {
    this.show_glovo = !this.show_glovo;
  }

  change_show_customer() {
    this.show_customer = !this.show_customer;
  }

  change_show_deliverect() {
    this.show_deliverect = !this.show_deliverect;
  }

  change_show_ordatic() {
    this.show_ordatic = !this.show_ordatic;
  }

  change_show_girona() {
    this.show_girona = !this.show_girona;
  }

  change_show_notes() {
    this.show_notes = !this.show_notes;
  }

}


// WEBPACK FOOTER //
// ./src/pages/components/popups/create-takeaway/create-takeaway.ts